import React from 'react'
import { WhiteButtonLink } from '../Buttons'
import { ShopCardCon } from './styles'
import { Img } from '../Image/Img'

type ShopCardProps = {
  productImg: string
  linkUrl: string
  team?: string
  player?: string
}

export const ShopCard: React.FC<React.PropsWithChildren<ShopCardProps>> = ({
  productImg,
  linkUrl,
  team,
  player,
}) => {
  const analytics = {
    event: 'shop_card_click',
    params: {
      btn_text: 'Shop Now',
      section: 'shop_card',
      team,
      player,
    },
  }
  return (
    <ShopCardCon>
      {productImg && <Img src={productImg} alt="Shopping items" />}
      <WhiteButtonLink href={linkUrl} analytics={analytics} aria-label={`Shop for ${team} ${player}`}>
        Shop Now
      </WhiteButtonLink>
    </ShopCardCon>
  )
}
